import { Link } from 'react-router-dom';
import { Card, CardContent, Button } from '../components/ui';

export default function About() {
  return (
    <div className="min-h-screen bg-dark-900 p-4 sm:p-6 flex items-center justify-center">
      <Card className="w-full max-w-3xl">
        <CardContent className="space-y-6">
          <div>
            <h1 className="text-2xl font-bold text-white">About Subscription Manager</h1>
            <p className="text-dark-400 mt-2">
              Track recurring subscriptions for multiple families with secure login, role-based admin,
              and monthly/yearly spending insights.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-white mb-2">What this app does</h2>
            <ul className="list-disc list-inside text-dark-300 space-y-1 text-sm">
              <li>Track all your recurring payments in one place.</li>
              <li>See monthly totals, yearly trends, and category-wise spending.</li>
              <li>Get forecasts so you know what you are likely to spend next.</li>
              <li>Organize subscriptions by family members for clearer visibility.</li>
              <li>Update, end, or remove subscriptions anytime.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-white mb-2">How sign-in works</h2>
            <ul className="list-disc list-inside text-dark-300 space-y-1 text-sm">
              <li>When your account is created, you get a temporary password.</li>
              <li>At your first login, you are asked to set a new password.</li>
              <li>This helps keep your account secure from day one.</li>
            </ul>
          </div>

          <div className="rounded-lg border border-dashed border-dark-600 bg-dark-800/40 p-3">
            <p className="text-sm text-dark-300 font-medium mb-2">Feature screenshots</p>
            <div className="grid grid-cols-1 gap-4">
              <div>
                <p className="text-xs text-dark-400 mb-2">App overview</p>
                <img
                  src="/images/login-overview.png"
                  alt="App overview screenshot"
                  className="w-full rounded-lg border border-dark-700"
                  loading="lazy"
                />
              </div>
              <div>
                <p className="text-xs text-dark-400 mb-2">Accounts and members</p>
                <img
                  src="/images/admin-overview.png"
                  alt="Accounts and members screenshot"
                  className="w-full rounded-lg border border-dark-700"
                  loading="lazy"
                />
              </div>
              <div>
                <p className="text-xs text-dark-400 mb-2">Projection and trends</p>
                <img
                  src="/images/projections-overview.png"
                  alt="Projection and trends screenshot"
                  className="w-full rounded-lg border border-dark-700"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className="flex justify-end">
            <Link to="/">
              <Button>Back to Login</Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
